export const VERSION = '2.43.0';
